import moment from 'moment';
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonMenuButton,
  IonTitle,
  IonContent,
  useIonViewDidEnter,
  useIonViewWillLeave
} from '@ionic/react';

import Stories from './components/Stories';
import ExerciseWorkouts from './components/ExerciseWorkout';
import FuelingPlans from './components/FuelingPlans';
import FileExplorer from './components/FileExplorer';

import videoFeedStore from 'stores/video-feed.store';
import workoutAssignmentStore from 'stores/workout-assignment.store';
import workoutAssignmentStatusStore from 'stores/workout-assignment-status.store';
import fuelingPlanStore from 'stores/fueling-plan.store';
import barwisFileStore from 'stores/barwis-file.store';

import classes from './style.module.scss';

const WORKOUT_ASSIGNMENT_FIELDS = `
  id
  start_date
  end_date
  notes
  workoutAssignmentCategory {
    id
    name
  }
  workout {
    id
    name
    description
    cover
    workoutTotalDays
  }
`;

const FUELING_PLAN_FIELDS = `
  id 
  name
  description
  cover  
  notes
  fuelingPlanCategory {
    id
    name
  }
`;

const BARWIS_FILE_FIELDS = `
  id
  name
  path
  created_at
  updated_at
`;

const DashboardPage = ({ match, history }) => {
  const fetchVideoFeeds = async () => {
    try {
      videoFeedStore.setFirst(6);
      videoFeedStore.setFields(`
        id 
        video_cover
      `);
      await videoFeedStore.searchObjects();
    } catch (error) {
      console.log(error);
    }
  };

  const fetchWorkoutAssignments = async () => {
    try {
      const searchDate = moment().format('YYYY-MM-DD');
      const query = {
        AND: [
          {
            column: 'start_date',
            operator: 'LTE',
            value: searchDate
          },
          {
            column: 'end_date',
            operator: 'GTE',
            value: searchDate
          }
        ]
      };
      workoutAssignmentStore.setFields(WORKOUT_ASSIGNMENT_FIELDS);
      workoutAssignmentStore.setQuery(query);
      await workoutAssignmentStore.searchObjects();
    } catch (error) {
      console.log(error);
    }
  };

  const fetchFuelingPlans = async () => {
    try {
      const searchDate = moment().format('YYYY-MM-DD');
      const query = {
        AND: [
          {
            column: 'start_date',
            operator: 'LTE',
            value: searchDate
          },
          {
            column: 'end_date',
            operator: 'GTE',
            value: searchDate
          }
        ]
      };
      fuelingPlanStore.setFields(FUELING_PLAN_FIELDS);
      fuelingPlanStore.setQuery(query);
      await fuelingPlanStore.searchObjects();
    } catch (error) {
      console.log(error);
    }
  };

  const fetchBarwisFiles = async () => {
    try {
      barwisFileStore.setFields(BARWIS_FILE_FIELDS);
      await barwisFileStore.searchObjects();
    } catch (error) {
      console.log(error);
    }
  };

  useIonViewDidEnter(() => {
    fetchVideoFeeds();
    fetchWorkoutAssignments();
    fetchFuelingPlans();
    fetchBarwisFiles();
  });

  useIonViewWillLeave(() => {
    videoFeedStore.resetAllFields();
    workoutAssignmentStore.resetAllFields();
    workoutAssignmentStatusStore.resetAllFields();
    fuelingPlanStore.resetAllFields();
    barwisFileStore.resetAllFields();
  });

  return (
    <IonPage id='dashboard'>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot='start'>
            <IonMenuButton></IonMenuButton>
          </IonButtons>
          <IonTitle>Dashboard</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className={classes.ionContent}>
        <Stories match={match} history={history} />
        <ExerciseWorkouts match={match} history={history} />
        <FuelingPlans match={match} history={history} />
        <FileExplorer match={match} history={history} />
      </IonContent>
    </IonPage>
  );
};

export default DashboardPage;
